import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { CLOTH_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
// import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";

import AddClothTypeForm from "./addClothTypeForm.component";
import ClothTypeList from "./clothTypeList.component";

const ClothTypeConfig = () => {
  // const { auth } = useAuth();
  const [clothTypeList, setClothTypeList] = useState([]);
  // const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editClothTypeDetails, setEditClothTypeDetails] = useState({});
  const isEdit = Object.keys(editClothTypeDetails).length > 0 ? true : false;

  const getClothTypeList = async () => {
    try {
      const response = await axios.get(CLOTH_TYPE_CONFIG_URL);
      // console.log("ClothType List", { response });
      response.status === 200 && setClothTypeList(response.data.clothTypeList);
      response.status === 202 &&
        showToast("No cloth type entries found in the system.", "error");
    } catch (error) {
      console.error("getClothTypeList", error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getClothTypeList();
      setEditClothTypeDetails({});
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    // <Dashboard sidebarType={auth.rolename}>
    <Dashboard>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Cloth type"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${
          isEdit ? "Update Cloth ype Details" : "Add Cloth Type Details"
        }`}
        isAdd={true}
        clearData={setEditClothTypeDetails}
      >
        <AddClothTypeForm
          getClothTypeList={getClothTypeList}
          editClothTypeDetails={editClothTypeDetails}
          setEditClothTypeDetails={setEditClothTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <ClothTypeList
          clothTypeList={clothTypeList}
          getClothTypeList={getClothTypeList}
          setEditClothTypeDetails={setEditClothTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default ClothTypeConfig;
